import { render, staticRenderFns } from "./TransferToOtherBanksModal.vue?vue&type=template&id=e4428cf8&scoped=true&"
import script from "./TransferToOtherBanksModal.vue?vue&type=script&lang=js&"
export * from "./TransferToOtherBanksModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferToOtherBanksModal.vue?vue&type=style&index=0&id=e4428cf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4428cf8",
  null
  
)

export default component.exports